<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="">
  <div class="">
    <div class="m-3">
      <div class="">
        <div class="">
          <mat-radio-group class="ms-1" [(ngModel)]="selectedOptionforDownload">
            <mat-radio-button class="ms-3" value="Issue Document" (change)="radioButtonDownloadChange($event)">
              <span>Issue Document</span>
            </mat-radio-button>
            <mat-radio-button value="Revision History" (change)="radioButtonDownloadChange($event)">
              <span>Revision History </span>
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <br *ngIf="selectedOptionforDownload == 'Revision History'" />
      <div *ngIf="selectedOptionforDownload == 'Revision History'" class="d-flex gap-4 ps-3">
        <div>
          <label for="title">Complete History</label>
          <div>
            <mat-slide-toggle color="primary" [(ngModel)]="completeHistory">
              <span class="active-inActive-container" *ngIf="completeHistory == true" [ngStyle]="
                    completeHistory == true ? { color: 'green' } : { color: '' }
                  ">
                Yes</span>
              <span *ngIf="completeHistory == false" [ngStyle]="
                    completeHistory == false ? { color: 'red' } : { color: '' }
                  ">No
              </span>
            </mat-slide-toggle>
          </div>
        </div>
        <div *ngIf="completeHistory == false">
          <label for="total yrs">Total Years</label>
          <input class="input-filed-continers" type="number" placeholder="Years" min="0" [(ngModel)]="historyYear"
            (keypress)="validateYear($event)" />
        </div>
        <div class="align-self-end" *ngIf="historyYear != null">
          <section>
            <mat-checkbox color="primary" (change)="checkBoxisLatestOnTop($event)" [checked]="isLatestOnTop">
              <span>Latest on top</span>
            </mat-checkbox>
          </section>
        </div>
      </div>

      <br *ngIf="selectedOptionforDownload == 'Revision History'" />
      <div *ngIf="selectedOptionforDownload == 'Issue Document'" class="">
        <div class="">
          <div class="">
            <fieldset class="border rounded-4 p-2 crFieldsetStyle">
              <legend class="float-none w-auto p-2" style="margin-bottom: 0px">
                <span class="" style="font-size: 14px; color: #cfcfcf">Type</span>
              </legend>
              <div class="row d-flex">
                <div class="col-md-3" [style.color]="isIssuanceTypeInvalid ? 'red' : ''">
                  <label for="email">Issuance Type<span class="mandatory-symbol" style="color: red;">*</span></label>
                  <div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="documentIssuanceType"
                      (closed)="issuanceTypeSearchText=''" (click)="focusSearch('focus-issuance-type-search')"
                      (keydown.enter)="focusSearch('focus-issuance-type-search')">
                      <input type="search" id="focus-issuance-type-search" class="dropdownsearchstyle"
                        [(ngModel)]="issuanceTypeSearchText" matInput placeholder="search">
                      <mat-option class="unselectStyle" [value]="null"
                        (onSelectionChange)="documentIssuanceSelect($event,null)">Un-select</mat-option>
                      <mat-option
                        *ngFor="let item of documentIssuanceTypeDropdown | assessmentSearch : issuanceTypeSearchText"
                        [value]="item.valueExp" (onSelectionChange)="documentIssuanceSelect($event,item)">
                        {{ item.displayExp }}
                      </mat-option>
                    </mat-select>
                    <span *ngIf="isIssuanceTypeInvalid"
                      style="color: red; font-size: 11px; margin-top: 2px; display: block;">
                      Issuance Type is mandatory.
                    </span>
                  </div>
                </div>
                <div class="col-md-2">
                  <label for="reason">Issued to</label>
                  <input type="text" [(ngModel)]="issuanceTo" class="input-filed-continers"
                    (focusout)="substitueWaterMsg()" />
                </div>
                <div class="col-md-2">
                  <label for="reason">Prints Taken<span class="mandatory-symbol" *ngIf="isPrintMode">*</span></label>
                  <input type="number" id="prints" min="1" (keydown)="validateIssuanceCopy($event)"
                    [(ngModel)]="issuanceCopy" class="input-filed-continers" (focusout)="substitueWaterMsg()" />
                </div>
                <div class="col-md-3">
                  <label for="reason">Issuance Reason</label>
                  <textarea type="text" [(ngModel)]="issuanceReason" rows="4" class="input-filed-continers"
                    (focusout)="substitueWaterMsg()"></textarea>
                </div>
                <div class="col-md-2">
                  <label for="reason">Report Logo</label>
                  <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
                    (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
                    (keydown.enter)="focusSearch('focus-Logo-search')">
                    <input type="search" id="focus-Logo-search" class="dropdownsearchstyle"
                      [(ngModel)]="pdfDetailSearchText" matInput placeholder="search">
                    <mat-option [value]="null" class="unselectStyle"
                      (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
                    <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
                      (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
                      {{ item.displayExp }}
                    </mat-option>
                  </mat-select>
                </div>
              </div>
              <div class="row mt-3 d-flex ">

                <div class="col-md-2">
                  <label for="reason">Download Template</label>
                  <mat-select class="input-filed-continers" placeholder="Select" [(ngModel)]="selectedDownloadTemplate"
                    (selectionChange)="onDownloadTemplateSelect($event)">

                    <mat-option style="color:red" [value]="null">Un-select</mat-option>

                    <mat-option *ngFor="let t of downloadTemplatesList" [value]="t.templateId">
                      {{ t.templateName }}
                    </mat-option>

                  </mat-select>

                </div>
                <div class="col-md-2" *ngIf="isFrom !='BULK'">
                  <label for="reason">Header Template</label>
                  <mat-select matInput placeholder="Select" [(ngModel)]="selectedHeaderTemplate"
                    (closed)="ReportHeaderSearchText=''" (click)="focusSearch('focus-Header-search')"
                    (keydown.enter)="focusSearch('focus-Header-search')">
                    <input type="search" id="focus-Header-search" class="dropdownsearchstyle"
                      [(ngModel)]="ReportHeaderSearchText" matInput placeholder="search">
                    <mat-option [value]="null" class="unselectStyle"
                      (onSelectionChange)="onHeaderTemplateSelect($event,null);">Un-select</mat-option>
                    <mat-option
                      *ngFor="let item of dropdownForHeaderReportTemplate | assessmentSearch : ReportHeaderSearchText"
                      (onSelectionChange)="onHeaderTemplateSelect($event,item)" [value]="item.valueExp">
                      {{ item.displayExp }}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="col-md-3" *ngIf="isFrom !='BULK' && !isPrintMode">
                  <label for="reason">Downloaded Document Name</label>
                  <textarea type="text" [(ngModel)]="documentNameForDownload" rows="4"
                    class="input-filed-continers"></textarea>
                </div>
                <div class="col-md-3">
                  <div> <label for="reason">Comments</label><span *ngIf="isFrom =='REDACT'"
                      class="mandatory-symbol">*</span></div>
                  <textarea id="comments" type="text" [(ngModel)]="comments" rows="4"
                    class="input-filed-continers"></textarea>
                  <span id="comments-required-msg">Please enter comments</span>
                </div>
                <div class="col-md-1" *ngIf="isFrom =='BULK'">
                  <div> <label class="form-control" for="reason"></label></div>
                  <input style="width: 20%;" [(colorPicker)]="watermarkColor" [style.background]="watermarkColor" />
                </div>
                <div class="col-md-4" *ngIf="isFrom !='BULK'">
                  <label for="reason">Watermark</label>
                  <div class="row">
                    <div class="col-md-11">
                      <textarea type="text" [(ngModel)]="documentWatermark" rows="4"
                        class="input-filed-continers"></textarea>
                    </div>
                    <div class="col-md-1">
                      <input style="width: 200%;" [(colorPicker)]="watermarkColor"
                        [style.background]="watermarkColor" />
                    </div>
                  </div>
                </div>

              </div>
            </fieldset>
          </div>
        </div>
        <div class="">
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2" style="margin-bottom: 0px">
              <span class="" style="font-size: 14px; color: #cfcfcf; margin-bottom: 0px">Additional Details</span>
            </legend>
            <!-- begin d-none added -->
            <div class="d-none row" style="padding-left: 15px !important">
              <div class="col-md-12">
                <div class="row" style="margin-bottom: 10px">
                  <div class="col-md-12" style="
                        padding-right: 0px;
                        padding-left: 0px;
                        border: 1px solid #0b095e;
                        height: auto;
                        padding-bottom: 15px;
                      ">
                    <div class="panel-heading">
                      <h3 class="panel-title" style="color: white">Add</h3>
                    </div>
                    <div class="row">
                      <div class="col-md-12" *ngFor="
                            let val of documentIssuanceTypeAddDropdown;
                            let i = index
                          ">
                        <div class="row">
                          <div class="col-md-3">
                            <div>
                              <label for="email ">{{ val.valueExp }}</label>
                            </div>
                            <mat-slide-toggle color="primary" [(ngModel)]="val.isChecked"
                              (change)="toggleChanged($event)">
                              <span class="active-inActive-container" *ngIf="val.isChecked == true" [ngStyle]="
                                    val.isChecked == true
                                      ? { color: 'green' }
                                      : { color: '' }
                                  ">Yes
                              </span>
                              <span *ngIf="val.isChecked == false" [ngStyle]="
                                    val.isChecked == false
                                      ? { color: 'red' }
                                      : { color: '' }
                                  ">No</span>
                            </mat-slide-toggle>
                          </div>
                          <div class="col-md-9" *ngIf="
                                val.isChecked &&
                                val.valueExp != 'Revision history' &&
                                val.valueExp != 'Approval'
                              ">
                            <input class="input-filed-continers" style="width: auto" type="text" [(ngModel)]="val.title"
                              [value]="val?.title" />
                          </div>

                          <div class="col-md-9" *ngIf="
                                val.isChecked && val.valueExp == 'Approval'
                              ">
                            <div class="row">
                              <div class="col-md-8"></div>
                              <div class="col-md-4">On Last Page</div>
                            </div>
                            <div class="row">
                              <div class="col-md-8">
                                <input class="input-filed-continers" style="width: auto" type="text"
                                  [(ngModel)]="val.title" [value]="val?.title" />
                              </div>
                              <div class="col-md-4">
                                <mat-slide-toggle color="primary" [(ngModel)]="onLastPage"
                                  [disabled]="isShowOnLatestTopDisabled">
                                  <span class="active-inActive-container" *ngIf="onLastPage == true" [ngStyle]="
                                        onLastPage == true
                                          ? { color: 'green' }
                                          : { color: '' }
                                      ">
                                    Yes</span>
                                  <span *ngIf="onLastPage == false" [ngStyle]="
                                        onLastPage == false
                                          ? { color: 'red' }
                                          : { color: '' }
                                      ">No
                                  </span>
                                </mat-slide-toggle>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-9" *ngIf="
                                val.isChecked &&
                                val.valueExp == 'Revision history'
                              ">
                            <div class="row">
                              <input class="input-filed-continers" style="width: auto" type="text"
                                [(ngModel)]="val.title" [value]="val?.title" />
                            </div>
                            <div class="row">
                              <div>Complete History</div>
                              <div class="row">
                                <div class="col-md-2">
                                  <mat-slide-toggle color="primary" [(ngModel)]="completeHistory">
                                    <span class="active-inActive-container" *ngIf="completeHistory == true" [ngStyle]="
                                          completeHistory == true
                                            ? { color: 'green' }
                                            : { color: '' }
                                        ">
                                      Yes</span>
                                    <span *ngIf="completeHistory == false" [ngStyle]="
                                          completeHistory == false
                                            ? { color: 'red' }
                                            : { color: '' }
                                        ">No
                                    </span>
                                  </mat-slide-toggle>
                                </div>
                                <div class="col-md-5" *ngIf="completeHistory == false">
                                  <div class="row">
                                    <div class="col-md-2">
                                      <label for="email "> Last </label>
                                    </div>
                                    <div class="col-md-6">
                                      <input class="input-filed-continers" type="number" min="0"
                                        [(ngModel)]="historyYear" (keypress)="validateYear($event)" />
                                    </div>
                                    <div class="col-md-3" style="margin-left: -5%">
                                      Year(s)
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-5">
                                  <div class="row" *ngIf="historyYear != null">
                                    <section style="color: black">
                                      <mat-checkbox [checked]="isLatestOnTop">
                                        <span style="color: gray; font-size: 15px">Latest on top</span>
                                      </mat-checkbox>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-bottom: 10px">
                  <div class="col-md-12" style="
                        padding-right: 0px;
                        padding-left: 0px;
                        border: 1px solid #0b095e;
                        height: auto;
                        padding-bottom: 15px;
                      ">
                    <div class="panel-heading">
                      <h3 class="panel-title" style="color: white">
                        Include
                      </h3>
                    </div>
                    <div class="row">
                      <div class="col-md-12" *ngFor="
                            let val of documentIssuanceTypeIncludeDropdown;
                            let i = index
                          ">
                        <div class="row" style="margin-bottom: 5px">
                          <div class="col-md-4">
                            <label for="email ">{{ val.valueExp }}</label>
                          </div>
                          <div class="col-md-3">
                            <mat-slide-toggle color="primary" [(ngModel)]="val.isChecked">
                              <span class="active-inActive-container" *ngIf="val.isChecked == true" [ngStyle]="
                                    val.isChecked == true
                                      ? { color: 'green' }
                                      : { color: '' }
                                  ">Yes
                              </span>
                              <span *ngIf="val.isChecked != true" [ngStyle]="
                                    val.isChecked != true
                                      ? { color: 'red' }
                                      : { color: '' }
                                  ">No</span>
                            </mat-slide-toggle>
                          </div>
                          <div class="col-md-5" *ngIf="val.valueExp == 'Notes' && val.isChecked">
                            <input class="input-filed-continers" type="text" [(ngModel)]="val.title" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <!-- end d-none added -->
            <div class="row d-flex">
              <div class="col-md-8">
                <div class="d-flex gap-3">
                  <div class="col-md-3">
                    <mat-checkbox color="primary" [(ngModel)]="incudeCoverPgae" (change)="toggleChanged($event)">
                      <span>Cover Page/Sign</span>
                    </mat-checkbox>
                    <div>
                      <input class="input-filed-continers" type="text" placeholder="Cover Page/Sign"
                        [(ngModel)]="incudeCoverPgaeTitle" [disabled]="!incudeCoverPgae" />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <mat-checkbox color="primary" [(ngModel)]="incudeAmendment">
                      <span>Amendment</span>
                    </mat-checkbox>
                    <div>
                      <input class="input-filed-continers" type="text" placeholder="Amendment"
                        [(ngModel)]="incudeAmendmentTitle" [disabled]="!incudeAmendment" />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <mat-checkbox color="primary" [(ngModel)]="incudeApproval"
                      (change)="onApprovalToggleChanged($event)">
                      <span>Approval</span>
                    </mat-checkbox>
                    <div>
                      <input class="input-filed-continers" type="text" placeholder="Approval"
                        [(ngModel)]="incudeApprovalTitle" [disabled]="!incudeApproval" />
                    </div>
                  </div>
                  <div class="col-md-2 align-self-center mt-3">
                    <label for="lastpage">On Last Page</label>
                    <div>
                      <mat-slide-toggle color="primary" [(ngModel)]="onLastPage" [disabled]="isShowOnLatestTopDisabled">
                        <span class="active-inActive-container" *ngIf="onLastPage==true"
                          [ngStyle]="onLastPage==true?{'color':'green'} : {'color': ''}"> Yes</span>
                        <span *ngIf="onLastPage==false" [ngStyle]="onLastPage==false?{'color':'red'} : {'color': ''}">No
                        </span>
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>
                <div class="d-flex gap-3 mt-2">

                  <div class="col-md-3">
                    <mat-checkbox color="primary" [(ngModel)]="incudeRevisionhistory" (change)="onRevisionToggle()">
                      <span>Revision History</span>
                    </mat-checkbox>
                    <div>
                      <input class="input-filed-continers" type="text" placeholder="Revision History"
                        [(ngModel)]="incudeRevisionhistoryTitle" [disabled]="!incudeRevisionhistory" />
                    </div>
                  </div>
                  <div class="col-md-3 align-self-center" *ngIf="incudeRevisionhistory">
                    <label for="completehistory">Complete History</label>
                    <div>
                      <mat-slide-toggle color="primary" [(ngModel)]="completeHistory">
                        <span class="active-inActive-container" *ngIf="completeHistory == true" [ngStyle]="
                              completeHistory == true ? { color: 'green' } : { color: '' }
                            ">
                          Yes</span>
                        <span *ngIf="completeHistory == false" [ngStyle]="
                              completeHistory == false ? { color: 'red' } : { color: '' }
                            ">No
                        </span>
                      </mat-slide-toggle>
                    </div>
                  </div>
                  <div class="col-md-3 align-self-end" *ngIf="completeHistory == false">
                    <label for="title" [ngClass]="incudeRevisionhistory == false ? 'disabled_title' : '#005C8A'">Total
                      Years</label>
                    <input [ngClass]="incudeRevisionhistory == false ? 'disabled_input' : ''" style="width:90%"
                      class="input-filed-continers" type="number" placeholder="Years" min="0" [(ngModel)]="historyYear"
                      (keypress)="validateYear($event)" [disabled]="incudeRevisionhistory == false" />
                  </div>

                  <div class="col-md-2 align-self-center mt-3">
                    <div class="row" *ngIf="historyYear != null">
                      <section style="color:black;">
                        <mat-checkbox color="primary" [checked]="isLatestOnTop">
                          <span>Latest on top</span>
                        </mat-checkbox>
                      </section>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4 align-self-center">
                <div class="d-flex justify-content-between mt-3">
                  <div class="col-md-6">
                    <mat-checkbox color="primary" [(ngModel)]="incudeFooter">
                      <span>Footer</span>
                    </mat-checkbox>
                  </div>
                  <div class="col-md-6">
                    <mat-checkbox color="primary" [(ngModel)]="incudePageNo">
                      <span>Page Number</span>
                    </mat-checkbox>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-3">
                  <div class="col-md-6">
                    <mat-checkbox color="primary" [(ngModel)]="publisherDetails">
                      <span>Publisher Details</span>
                    </mat-checkbox>
                  </div>
                  <div class="col-md-6">
                    <mat-checkbox color="primary" [(ngModel)]="linkedDocuments">
                      <span>Linked Documents</span>
                    </mat-checkbox>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-3">
                  <div class="col-md-6">
                    <mat-checkbox color="primary" [(ngModel)]="incudeNotes">
                      <span>Notes</span>
                    </mat-checkbox>
                  </div>
                  <div class="col-md-6">
                    <input class="input-filed-continers" type="text" placeholder="Notes" [(ngModel)]="incudeNotesTitle"
                      [disabled]="!incudeNotes" (ngModelChange)="onNotesChange($event)" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row d-flex">
              <div class="col-md-3">
                <mat-checkbox color="primary" [(ngModel)]="incudeAdditionalDetails">
                  <span>Additional Details</span>
                </mat-checkbox>
                <div>
                  <input class="input-filed-continers" type="text" placeholder="Additional Details"
                    [(ngModel)]="incudeAdditionalDetailsTitle" [disabled]="!incudeAdditionalDetails" />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="ps-3 row" *ngIf="
            selectedOptionforDownload != 'Issue Document' &&
            selectedOptionforDownload != null
          ">
        <div class="col-md-5" *ngIf="isFrom !='BULK'">
          <label for="watermark">Watermark</label>
          <textarea rows="6" type="text" [(ngModel)]="documentWatermark" class="input-filed-continers"></textarea>
        </div>
        <div class="col-md-4">
          <label for="reason">Comments</label>
          <textarea type="text" [(ngModel)]="comments" rows="4" class="input-filed-continers"></textarea>
        </div>
        <div class="col-md-3" *ngIf="isFrom !='BULK'">
          <label for="reason">Downloaded Document Name</label>
          <textarea type="text" [(ngModel)]="documentNameForDownload" rows="4" class="input-filed-continers"></textarea>
        </div>

        <div class="col-md-2" *ngIf="isPrintMode">
          <label for="reason">Prints Taken<span class="mandatory-symbol" ngIF="isPrintMode">*</span></label>
          <input type="number" id="printstaken" min="1" (keydown)="validateIssuanceCopy($event)"
            [(ngModel)]="issuanceCopy" class="input-filed-continers" (focusout)="substitueWaterMsg()" />
        </div>
      </div>
    </div>

    <div class="border-top">
      <div class="button-continer d-flex gap-3 justify-content-end py-2" mat-dialog-actions>
        <button *ngIf="!isPrintMode && isFrom !='BULK'" mat-stroked-button
          class="training_btn d-flex gap-1 align-items-center" (click)="downloadFordocument('DOCSAVE')"> Submit As Job
        </button>
        <button *ngIf="!isPrintMode && showPreviewButton" mat-stroked-button
          class="training_btn d-flex gap-1 align-items-center" (click)="downloadForPrint('DOCDOWNLOAD')">
          Preview
        </button>
        <button *ngIf="isPrintMode" mat-stroked-button class="training_btn d-flex gap-1 align-items-center"
          (click)="downloadForPrint('DOCDOWNLOAD')">
          <img src="../../assets/img/DMS/download.svg" width="18px" height="18px" alt="download"> Preview And Print
        </button>
        <button *ngIf="!isPrintMode" mat-stroked-button class="training_btn d-flex gap-1 align-items-center"
          (click)="downloadFordocument('DOCDOWNLOAD')">
          <img src="../../assets/img/DMS/download.svg" width="18px" height="18px" alt="download"> Download
        </button>

        <button mat-stroked-button class="cancelButton" (click)="cancelDownloadFunction()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</div>
<ng-template #infoPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="okInfo()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Information</label>
    <label for="popup" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div class="row">
      <div class="col-md-12">
        {{warningMsg}}
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="okInfo()"
        (keydown.enter)="okInfo()">
        <span class="reload_text text-white">OK</span>
      </div>
    </div>
  </div>
</ng-template>

<app-document-viewer-printer #viewPopup2 [docViewer]="docViewer"
  *ngIf="isPrintMode && docViewer?.doc"></app-document-viewer-printer>
<app-document-viewer #viewPopup [docViewer]="docViewer" *ngIf="!isPrintMode && docViewer?.doc"></app-document-viewer>
<ng-template #downloadTrackerPopup>
  <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">

    <button class="close close-button" (click)="closeDownloadTracker()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <button class="close close-button" (click)="toggleMinimizeTracker()" mat-button>
      <i class="fa popupClose" [ngClass]="isTrackerMinimized ? 'fa-window-maximize' : 'fa-window-minimize'"
        style="font-size: 14px;"></i>
    </button>

    <div mat-dialog-title cdkDragHandle style="cursor: move;">
      <label for="title" class="popupTitle" style="cursor: move;">Download Progress</label>
    </div>

    <div [hidden]="isTrackerMinimized"
      style="margin: 10px 15px; max-height: 250px; overflow-y: auto; overflow-x: hidden;width:100%;">
      <table class="dynamic-table-container documentTable" style="width: 100%;">
        <thead>
          <tr>
            <th style="min-width: 200px; text-align: left; padding: 10px; border-bottom: 1px solid #dee2e6;">Document
              Name</th>
            <th style="min-width: 120px; text-align: left; padding: 10px; border-bottom: 1px solid #dee2e6;">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let item of downloadProgressList"
            style="border-bottom: 1px solid #ddd;">
            <td class="row-data"
              style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding: 8px;"
              [title]="item.documentName">
              {{ item.documentName }}
            </td>
            <td class="row-data" style="padding: 8px;">
              <span *ngIf="item.status === 'Pending'" style="color: gray;">Pending...</span>

              <span *ngIf="item.status === 'Downloading...'" style="color: #005C8A;">
                Processing <i class="fa fa-spinner fa-spin ms-1"></i>
              </span>

              <span *ngIf="item.status === 'Success'" style="color: green;">
                <b>Completed</b> <i class="fa fa-check-circle ms-1"></i>
              </span>

              <span *ngIf="item.status === 'Failed'" style="color: red;" [title]="item.errorMessage">
                <b>Failed</b> <i class="fa fa-times-circle ms-1"></i> <br>
                <small style="font-size: 10px;">{{item.errorMessage}}</small>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</ng-template>